import { ChangeEvent, useEffect, useState } from 'react';
import Button from '../../../shared/button';
import { useProductTeamStatisticsMutation } from '../../../store/chatbox/chatboxApi';
import Select from '../../../shared/select';
import ReportedIssuesModal from './modals/ReportedIssuesModal';

const DashboardStats = ({
	hotelId
}: {
	hotelId: string
}) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [statsIndex, setStatsIndex] = useState<number>(0);
    const [dashboardStats, { data }] = useProductTeamStatisticsMutation();

    const getDashboardStats = async (hotelId: string, sourceName?: string) => {
        try {
            await dashboardStats(
                sourceName ? { hotelId } : { hotelId, sourceName },
            ).unwrap();
        } catch (e) {
            console.error({ e });
        }
    };

    const handleSetIndex = ({ target }: ChangeEvent<HTMLSelectElement>) => {
        setStatsIndex(+target.value);
    };

    const handleToggleModal = () => setShowModal((modal) => !modal);

    useEffect(() => {
        if (hotelId) getDashboardStats(hotelId);
    }, [hotelId]);

    const options =
        data?.data.elements.map((element, index) => ({
            value: index,
            label: element.topic,
        })) || [];

    return (
        <div className="flex flex-wrap my-4 -mx-2">
            <div className="w-full md:w-5/12 px-2">
                <div className="border border-gray-200 rounded-2xl p-6">
                    <h5 className="text-sm font-normal text-[#1C1C1C] mb-3 flex flex-wrap dark:text-white">
                        <span className="mt-2">
                            {data?.data.elements[statsIndex]?.topic}
                        </span>
                        <div className="ml-auto w-40 text-primary-dark">
                            <Select
                                showValue
                                value={options[statsIndex]?.value}
                                options={options}
                                onChangeSelectValue={handleSetIndex}
                            />
                        </div>
                    </h5>
                    <div className="bg-gray-200 dark:bg-black rounded-2xl w-full h-60" />
                </div>
            </div>
            <div className="w-full md:w-7/12 px-2">
                <div className="border border-gray-200 rounded-2xl p-6 h-full">
                    <h5 className="text-sm font-normal text-[#1C1C1C] mb-3 flex flex-row items-center pr-2 dark:text-white">
                        {data?.data.elements[statsIndex]?.topic} - Ratings
                        <Button
                            label="View all Queries"
                            onClickButton={handleToggleModal}
                            className="ml-auto rounded-2xl bg-primary-default text-white py-2 px-5"
                        />
                    </h5>
                    <div className="w-full">
                        {data?.data.elements[statsIndex]?.allInfo
                            .slice(0, 11)
                            .map((info) => (
                                <div
                                    key={info.data.question}
                                    className="flex flex-wrap mb-2">
                                    <div className="w-6/12">
                                        <p className="text-xs text-[#1C1C1C] dark:text-white">
                                            {info.data.question}
                                        </p>
                                    </div>
                                    <div className="w-6/12">
                                        <div className="ml-2 flex flex-row">
                                            <div
                                                className="h-1.5 rounded-lg bg-[#EF4444]"
                                                style={{
                                                    width:
                                                        (info.totalDislikedPerQuestion /
                                                            info.totalPerQuestion) *
                                                            100 +
                                                        '%',
                                                }}
                                            />
                                            <div
                                                className="h-1.5 rounded-lg bg-[#F59E0B]"
                                                style={{
                                                    width:
                                                        (info.totalNoRatingsPerQuestion /
                                                            info.totalPerQuestion) *
                                                            100 +
                                                        '%',
                                                }}
                                            />
                                            <div
                                                className="h-1.5 rounded-lg bg-[#10B981]"
                                                style={{
                                                    width:
                                                        (info.totalLikedPerQuestion /
                                                            info.totalPerQuestion) *
                                                            100 +
                                                        '%',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
            <ReportedIssuesModal
                handleCloseModal={handleToggleModal}
                openModal={showModal}
                data={data?.data.elements[statsIndex]}
				hotelId={hotelId}
            />
        </div>
    );
};

export default DashboardStats;
